"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "DigitalSignature___StyledSvg",
  componentId: "sc-15nzyod-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function DigitalSignature(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M13.429 5.864V3.692C15.559 2.566 18 2 18 2s-1.05 4.547-3.148 6.647c-1.431 1.43-2.664 1.756-3.55 1.575l-3.207 3.207v-1.524l2.21-2.209c-.774-.773-1.05-2.45 1.048-4.548.22-.22.472-.426.738-.623l1.338 1.339z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    d: "M3.524 18h8.38c.841 0 1.525-.684 1.525-1.524v-4.571h-1.524v4.571H3.524v-8.38h4.571V6.57H3.524C2.684 6.571 2 7.256 2 8.095v8.381C2 17.316 2.683 18 3.524 18z",
    fill: "currentColor"
  }));
}

var _default = DigitalSignature;
exports["default"] = _default;